import React, { useState } from 'react';
import './StudentPages.css';

const StudentAI = () => {
  const [messages, setMessages] = useState([
    { role: 'ai', text: 'Hi! I am your AI placement assistant. Ask me anything about aptitude, logical reasoning, or placement preparation!' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;
    const userMsg = input.trim();
    setInput('');
    setMessages(prev => [...prev, { role: 'user', text: userMsg }]);
    setLoading(true);

    try {
      const response = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model: 'claude-sonnet-4-20250514',
          max_tokens: 1000,
          system: 'You are a placement preparation AI assistant for engineering students in India. Help them with aptitude questions, logical reasoning, verbal ability, programming concepts, and placement interview tips. Keep answers concise and practical.',
          messages: [{ role: 'user', content: userMsg }]
        })
      });
      const data = await response.json();
      const aiText = data.content?.[0]?.text || 'Sorry, I could not process that.';
      setMessages(prev => [...prev, { role: 'ai', text: aiText }]);
    } catch (err) {
      setMessages(prev => [...prev, { role: 'ai', text: 'Connection error. Please try again.' }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="ai-page-content">
        <div className="s-page-header">
          <h2>AI Assistant</h2>
          <p>Ask anything about aptitude, placement prep, or practice questions</p>
        </div>

        <div className="ai-chat-wrapper">
          <div className="ai-messages">
            {messages.map((m, i) => (
              <div key={i} className={`ai-msg ${m.role}`}>
                {m.role === 'ai' && <div className="ai-msg-avatar">AI</div>}
                <div className="ai-msg-bubble">{m.text}</div>
                {m.role === 'user' && <div className="ai-msg-avatar user">Me</div>}
              </div>
            ))}
            {loading && (
              <div className="ai-msg ai">
                <div className="ai-msg-avatar">AI</div>
                <div className="ai-msg-bubble ai-typing">
                  <span /><span /><span />
                </div>
              </div>
            )}
          </div>

          <div className="ai-input-row">
            <input
              className="ai-input"
              placeholder="Ask a question... e.g. 'Explain time and work problems'"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && sendMessage()}
            />
            <button className="ai-send-btn" onClick={sendMessage} disabled={loading}>
              Send →
            </button>
          </div>

          <div className="ai-suggestions">
            {['Explain profit & loss', 'Give me a logical puzzle', 'Tips for coding interviews', 'Explain blood relations'].map((s, i) => (
              <button key={i} className="ai-suggestion" onClick={() => { setInput(s); }}>
                {s}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentAI;